/* lua.js generated code 0.3.0 */

require("clover/panel/component/common/uiGroupButtonLayout/UIGLabelButton")
require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var GameGuideTimelineAnims = require("clover/gameGuide/GameGuideTimelineAnims")
var GameGuideFunc = require("clover/gameGuide/GameGuideFunc")
var GameGuidePosition = require("clover/gameGuide/GameGuidePosition")
var GameGuideAnims = {}
GameGuideAnims.handClick = function (action, paras) {
    var self = this
    var anim = cc.Node.create()
    FrameLoader.loadImageWithPlist("cocos/game_guide.plist")
    var hand = cc.Sprite.createWithSpriteFrameName("game_guide/hand.png")
    hand.setAnchorPoint(cc.p(1, 0))
    hand.setOpacity(0)
    anim.addChild(hand)
    hand.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.CallFunc.create(function () {
        var pos = cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio))
        hand.setPosition(cc.p(pos.x + 90, pos.y - 50))
        hand.setRotation(10.5)
        hand.setOpacity(0)
        hand.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.FadeIn.create(0.2), cc.RotateTo.create(0.26, -19.5), cc.RotateTo.create(0.126, 10.5))))
    })))
    anim.remove = function (self) {
        self.removeFromParent(true)
    }
    return anim
}
// 用于棋盘交换 只有四个轴向运动有拖尾
// var directionParam = table(
//     [1, 2, table(
//         [1, "scaleX", 1],
//         [1, "scaleY", -1.5],
//         [1, "tScaleX", 1.38],
//         [1, "tScaleY", -1.5],
//         [1, "tScaleX2", 1.55],
//         [1, "tScaleY2", -1.5],
//         [1, "rotation", 90],
//         [1, "position", cc.p(25, -45)]
//     )],
//     [1, 4, table(
//         [1, "scaleX", -1],
//         [1, "scaleY", -1.5],
//         [1, "tScaleX", -1.38],
//         [1, "tScaleY", -1.5],
//         [1, "tScaleX2", -1.55],
//         [1, "tScaleY2", -1.5],
//         [1, "rotation", 0],
//         [1, "position", cc.p(0, -20)]
//     )],
//     [1, 6, table(
//         [1, "scaleX", 1],
//         [1, "scaleY", 1.5],
//         [1, "tScaleX", 1.38],
//         [1, "tScaleY", 1.5],
//         [1, "tScaleX2", 1.55],
//         [1, "tScaleY2", 1.5],
//         [1, "rotation", 0],
//         [1, "position", cc.p(15, -20)]
//     )],
//     [1, 8, table(
//         [1, "scaleX", 1],
//         [1, "scaleY", -1.5],
//         [1, "tScaleX", 1.38],
//         [1, "tScaleY", -1.5],
//         [1, "tScaleX2", 1.55],
//         [1, "tScaleY2", -1.5],
//         [1, "rotation", -90],
//         [1, "position", cc.p(20, -10)]
//     )]
// )
var directionParam = table(
    [1, 2, table(
        [1, "scaleX", 0.1],
        [1, "scaleY", -1],
        [1, "tScaleX", 1],
        [1, "tScaleY", -1],
        [1, "tScaleX2", 1.55],
        [1, "tScaleY2", -1.5],
        [1, "rotation", 90],
        [1, "position", cc.p(0, 30)]
    )],
    [1, 4, table(
        [1, "scaleX", -0.1],
        [1, "scaleY", -1],
        [1, "tScaleX", -1],
        [1, "tScaleY", -1],
        [1, "tScaleX2", -1.55],
        [1, "tScaleY2", -1.5],
        [1, "rotation", 0],
        [1, "position", cc.p(30, 0)]
    )],
    [1, 6, table(
        [1, "scaleX", 0.1],
        [1, "scaleY", 1],
        [1, "tScaleX", 1],
        [1, "tScaleY", 1],
        [1, "tScaleX2", 1.55],
        [1, "tScaleY2", 1.5],
        [1, "rotation", 0],
        [1, "position", cc.p(-30, 0)]
    )],
    [1, 8, table(
        [1, "scaleX", 0.1],
        [1, "scaleY", -1],
        [1, "tScaleX", 1],
        [1, "tScaleY", -1],
        [1, "tScaleX2", 1.55],
        [1, "tScaleY2", -1.5],
        [1, "rotation", -90],
        [1, "position", cc.p(0, -30)]
    )]
)
GameGuideAnims.handSwap = function (action, paras) {
    var self = this
    var anim = cc.Node.create()
    FrameLoader.loadImageWithPlist("cocos/game_guide.plist")
    var hand = cc.Sprite.createWithSpriteFrameName("game_guide/hand.png")
    hand.setRotation(-4.5)
    hand.setOpacity(0)
    anim.addChild(hand)
    var from = cc.p(...GameGuidePosition.getPosition(action.from.posMode, (paras || table()).panel, action.from.p1, action.from.p2, action.from.width, action.from.height, action.from.posRatio, action.from.posAdd, action.from.sizeRatio))
    var to = cc.p(...GameGuidePosition.getPosition(action.to.posMode, (paras || table()).panel, action.to.p1, action.to.p2, action.to.width, action.to.height, action.to.posRatio, action.to.posAdd, action.to.sizeRatio))
    var diffVec = cc.pNormalize(cc.pSub(to, from))
    var direction = 5 + diffVec.y * 3 + diffVec.x
    var winSize = cc.Director.getInstance().getWinSize();
    cc.log("GameGuideAnims.handSwap direction ",direction,diffVec,winSize)
    let hand_pos = cc.p(...GameGuidePosition.getPosition(action.from.posMode, (paras || table()).panel, action.from.p1, action.from.p2, action.from.width, action.from.height, action.from.posRatio, action.from.posAdd, action.from.sizeRatio))

    let d_scaleX = 1
    let d_tScaleX = 1
    let d_tScaleX2 = 1
    let d_scaleY = 1
    let d_tScaleY = 1
    let d_tScaleY2 = 1
    let tracer_offset = 0
    var tracer
    if (directionParam[direction]) {
        d_scaleX = directionParam[direction].scaleX
        d_tScaleX = directionParam[direction].tScaleX 
        d_tScaleX2 = directionParam[direction].tScaleX2 

        // let change_scale = 1
        // if(direction == 2 || direction == 8){//针对 上下滑动对 手指处于靠右边的情况做出处理
        //     change_scale = hand.scaleX
        // }
        if (hand_pos.x > winSize.width/2){
            hand.scaleX = -1
        }
        d_scaleY = directionParam[direction].scaleY 
        d_tScaleY = directionParam[direction].tScaleY 
        d_tScaleY2 = directionParam[direction].tScaleY2 


        tracer = cc.Sprite.createWithSpriteFrameName("game_guide/tracer2.png")
        tracer.setAnchorPoint(cc.p(0, 0.5))
        tracer.setScaleX(d_scaleX || 1)
        tracer.setScaleY(d_scaleY || 1)
        tracer.setRotation(directionParam[direction].rotation || 0)
        tracer.setLocalZOrder(-1)
        tracer.setOpacity(0)
        anim.addChild(tracer)
    }
    hand.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.CallFunc.create(function () {
        let pos = hand_pos
        // var pos = cc.p(...GameGuidePosition.getPosition(action.from.posMode, (paras || table()).panel, action.from.p1, action.from.p2, action.from.width, action.from.height, action.from.posRatio, action.from.posAdd, action.from.sizeRatio))
        hand.setPosition(cc.p(pos.x + 25*hand.scaleX, pos.y - 30))
        hand.runAction(
            cc.RepeatForever.create(
                cc.Sequence.create(
                    cc.FadeIn.create(0.13),
                    cc.EaseSineOut.create(cc.MoveBy.create(0.345, cc.pSub(to, from))), 
                    cc.DelayTime.create(0.13), 
                    cc.DelayTime.create(0.5),
                    cc.FadeOut.create(0.08), 
                    cc.DelayTime.create(2), 
                    cc.CallFunc.create(function () {
                        var position = cc.p(hand.getPosition())
                        hand.setPosition(cc.pAdd(position, cc.pSub(from, to)))
        }))))
    })))
    if (tracer) {
        // tracer.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.CallFunc.create(function () {
        //     var pos = cc.p(...GameGuidePosition.getPosition(action.from.posMode, (paras || table()).panel, action.from.p1, action.from.p2, action.from.width, action.from.height, action.from.posRatio, action.from.posAdd, action.from.sizeRatio))
        //     var dPos = directionParam[direction].position || cc.p(0, 0)
        //     tracer.setPosition(cc.p(pos.x + dPos.x, pos.y + dPos.y))
        //     tracer.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.DelayTime.create(0.13), cc.Spawn.create(cc.MoveBy.create(0.345, cc.pSub(to, from)), cc.Sequence.create(cc.FadeIn.create(0.13), cc.DelayTime.create(0.085 + 0.13), cc.FadeOut.create(0.13),cc.DelayTime.create(1)), cc.Sequence.create(cc.ScaleTo.create(0.13, d_tScaleX, d_tScaleY), cc.ScaleTo.create(0.13, d_tScaleX2, d_tScaleY2))), cc.DelayTime.create(0.08), cc.DelayTime.create(2), cc.CallFunc.create(function () {
        //         var position = cc.p(tracer.getPosition())
        //         tracer.setPosition(cc.pAdd(position, cc.pSub(from, to)))
        //         tracer.setScaleX(d_scaleX)
        //         tracer.setScaleY(d_scaleY)
        //     }))))
        // })))
        tracer.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.CallFunc.create(function () {
            var pos = cc.p(...GameGuidePosition.getPosition(action.from.posMode, (paras || table()).panel, action.from.p1, action.from.p2, action.from.width, action.from.height, action.from.posRatio, action.from.posAdd, action.from.sizeRatio))
            var dPos = directionParam[direction].position || cc.p(0, 0)
            tracer.setPosition(cc.p(pos.x + dPos.x, pos.y + dPos.y))
            let tracerAction = cc.Sequence.create(
                cc.DelayTime.create(0.13),
                cc.Spawn.create(
                    cc.Sequence.create(cc.FadeIn.create(0.13), cc.DelayTime.create(0.085 + 0.13), cc.FadeOut.create(1.13-0.5)
                    ),
                    cc.ScaleTo.create(0.26, d_tScaleX, d_tScaleY),
                    // cc.Sequence.create(
                    //     cc.DelayTime.create(0.13), 
                    //     cc.DelayTime.create(0.13), 

                    // ),
                    // cc.DelayTime.create(0.13), 
                   
                ),
                cc.DelayTime.create(0.08), 
                cc.DelayTime.create(2),
                cc.CallFunc.create(()=>{
                    tracer.setScaleX(d_scaleX)
                    tracer.setScaleY(d_scaleY)
                })
            )
            tracer.runAction(cc.RepeatForever.create(
                tracerAction
            ))
            // tracer.runAction(cc.RepeatForever.create(
            //     cc.Sequence.create(
            //         cc.DelayTime.create(0.13), 
            //         cc.Spawn.create(
            //             cc.Sequence.create(
            //                 cc.FadeIn.create(0.13), 
            //                 cc.DelayTime.create(0.085 + 0.13), 
            //                 cc.FadeOut.create(1.13)
            //                 ), 
            //                 cc.Sequence.create(
            //                     cc.ScaleTo.create(0.13, d_tScaleX, d_tScaleY), 
            //                     cc.ScaleTo.create(0.13, d_tScaleX2, d_tScaleY2))), 
            //                     cc.DelayTime.create(0.08), cc.DelayTime.create(2), 
            //                     cc.CallFunc.create(function () {
            //     var position = cc.p(tracer.getPosition())
            //     // tracer.setPosition(cc.pAdd(position, cc.pSub(from, to)))
            //     tracer.setScaleX(d_scaleX)
            //     tracer.setScaleY(d_scaleY)
            // }))))
        })))
    }
    anim.remove = function (self) {
        self.removeFromParent(true)
    }
    return anim
}
GameGuideAnims.lockGamePropBarSlide = function (action, paras) {
    var self = this
    var node = cc.Node.create()
    var scene = GameGuideData.getInstance().getScene()
    if (scene === "GameScene") {
        var scene = cc.Director.getInstance().getRunningScene()
        var propBar = ((scene || table()).ui || table()).gamePropBar
        if (propBar) {
            propBar.setSlideEnabled(false)
        }
    }
    node.onCleanup = function (self) {
        var scene = GameGuideData.getInstance().getScene()
        if (scene === "GameScene") {
            var scene = cc.Director.getInstance().getRunningScene()
            var propBar = ((scene || table()).ui || table()).gamePropBar
            if (propBar) {
                propBar.setSlideEnabled(true)
            }
        }
    }
    return node
}
GameGuideAnims.skipButton = function (action, paras) {
    var self = this
    var vSize = cc.Director.getInstance().getVisibleSize()
    var text = cc.Label.createWithSystemFont(getText("tutorial.skip"), null, 36)
    // text.setColor(cc.c4b(102, 204, 255, 255))
    text.setColor(cc.c4b(240, 255, 255, 255))
    text.setAnchorPoint(cc.p(0, 0))
    text.setPosition(cc.p(20, 20))
    var button = UIButton.create(cc.Node.create(), true)
    var size = text.getContentSize()
    button.setContentSize(cc.size(size.width + 40, size.height + 40))
    button.addChild(text)
    button.setCascadeOpacityEnabled(true)
    button.setOpacity(0)
    button.runAction(cc.Spawn.create(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.FadeIn.create(action.fade || 0)), cc.Sequence.create(cc.DelayTime.create(action.touchDelay || 0), cc.CallFunc.create(function () {
        button.on(UIButtonEvent.Click, function () {
            var data = GameGuideData.getInstance()
            for (var i = 1, v = (action.guide || table())[1]; v; i++ , v = (action.guide || table())[i]) {
                data.incGuidedIndex(v)
            }
            for (var i = 1, v = (action.succeed || table())[1]; v; i++ , v = (action.succeed || table())[i]) {
                data.incSucceedGuideIndex(v)
            }
            GameGuide.getInstance().onGuideComplete(true)
            GameGuide.getInstance().dispatchEvent(table([1, "name", GameGuideEvents.SkipGuide]))
        })
    }))))
    button.setAnchorPoint(cc.p(0.5, 0.5))
    if (isWechatGameEnv()) {
        button.setPosition(cc.p(vSize.width - size.width / 2 - 20, size.height / 2 + 20 + _safe_area_bottom))
    }else {
        // button.setPosition(cc.p(vSize.width - size.width / 2 - 20, vSize.height - size.height / 2 - 20 - _safe_area_top))
        button.setPosition(cc.p(vSize.width - size.width / 2 - 20, size.height / 2 + 20 + _safe_area_bottom))
    }
    return button
}
GameGuideAnims.autoFinishNode = function (action, paras) {
    var self = this
    var node = cc.Node.create()
    node.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 5), cc.CallFunc.create(function () {
        GameGuide.getInstance().onGuideComplete()
    })))
    return node
}
GameGuideAnims.guideProp = function (action, paras) {
    var self = this
    var node = cc.Node.create()
    node.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.CallFunc.create(function () {
        GameGuideFunc.guideProp(action, paras)
        node.removeFromParent(true)
    })))
    return node
}
GameGuideAnims.propInteractLimit = function (action, paras) {
    var self = this
    var node = cc.Node.create()
    var scene = cc.Director.getInstance().getRunningScene()
    if (((scene || table()).class || table()).__cname === "GameScene") {
        var view = scene.view
        if (view && view.setInteractionLimit) {
            view.setInteractionLimit(action.pos, action.dir)
        }
    }
    node.enableNodeEvents()
    node.onCleanup = function (self) {
        var scene = cc.Director.getInstance().getRunningScene()
        if (((scene || table()).class || table()).__cname === "GameScene") {
            var view = scene.view
            if (view && view.resetInteractionLimit) {
                view.resetInteractionLimit()
            }
        }
    }
    return node
}
GameGuideAnims.singleAnimation = function (action, paras) {
    var self = this
    var anim = action.anim || table()
    var config = table(
        [1, "type", anim.type],
        [1, "propId", anim.propId],
        [1, "obstName", anim.obstName],
        [1, "delay", anim.delay],
        [1, "replay", anim.replay]
    )
    var anim = GameGuideTimelineAnims.timelineAnims(config)
    anim.setCascadeOpacityEnabled(true)
    var [x, y] = GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)
    anim.setPosition(cc.p(x, y))
    var scale = action.scale || cc.p(1, 1)
    anim.setScaleX(scale.x)
    anim.setScaleY(scale.y)
    anim.setOpacity(0)
    anim.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.FadeIn.create(action.fade || 0)))
    return anim
}
GameGuideAnims.singleText = function (action, paras) {
    var self = this
    var vSize = cc.Director.getInstance().getVisibleSize()
    var text = self.createMixedText(getText(tostring(action.text), table([1, "n", "\n"])), action.fontSize || 30, action.fontColor || cc.c4b(0, 0, 0, 255), action.width || vSize.width, action.textAlign || "center")
    text.setCascadeOpacityEnabled(true)
    var [x, y] = GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)
    text.setPosition(cc.p(x, y))
    text.setOpacity(0)
    text.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.FadeIn.create(action.fade || 0)))
    return text
}
GameGuideAnims.singleBubble = function (action, paras) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    scale = scale * scrScale
    var bubble = self.bubblePanel(action, (action.delay || 0) + (action.fade || 0))
    bubble.setScale(scale * bubble.getScale())
    bubble.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    return bubble
}
GameGuideAnims.singleBoard = function (action, paras) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    scale = scale * scrScale
    var board = self.boardPanel(action, (action.delay || 0) + (action.fade || 0))
    board.setScale(scale * board.getScale())
    board.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    return board
}
GameGuideAnims.singleButton = function (action, paras) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    scale = scale * scrScale
    var res = cc.CSLoader.createNode("cocos/game_guide_btn_green_start.csb")
    var button = UIGLabelButton.create(res, true)
    if (action.size) {
        var size = action.size
        var normal = button.getChildByName("normal")
        var click = button.getChildByName("click")
        var disabled = button.getChildByName("disabled")
        normal.setContentSize(size)
        normal.setPosition(cc.p(-size.width / 2, size.height / 2))
        click.setContentSize(size)
        click.setPosition(cc.p(-size.width / 2, size.height / 2))
        disabled.setContentSize(size)
        disabled.setPosition(cc.p(-size.width / 2, size.height / 2))
        button.setContentSize(size)
    }
    button.setCascadeOpacityEnabled(true)
    button.setString(getText(tostring(action.text || getText("clover.text.6"))))
    PushBounceAnim.create(button)
    button.setEnabled(false, true)
    button.setOpacity(0)
    button.setScale(0)
    action.delay = 1  //新手引导按钮加快
    button.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    button.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.Spawn.create(cc.ScaleTo.create(0.2, 1.2 * scale), cc.FadeIn.create(0.2)), cc.ScaleTo.create(0.26, scale), cc.CallFunc.create(function () {
        button.setEnabled(true, true)
    })))
    button.on(UIButtonEvent.Click, function (evt) {
        var behavior = action.behavior || "exit"
        if (behavior === "exit") {
            GameGuide.getInstance().onGuideComplete()
        } else if (behavior === "replay") {
            GameGuide.getInstance().onRunReplayGuide(action.para)
        }
    })
    return button
}
GameGuideAnims.imageMoveInfiProp = function (icon, action, x1, y1, x2, y2, root) {
    let self = this
    // touch layer 
    if (!isPlatformIOS()){
        return
    }
    let layer = null
    if (root) {
        layer = cc.Layer.create()
        let listenner = cc.EventListenerTouchOneByOne.create()
        listenner.setSwallowTouches(true)
        listenner.registerScriptHandler(function (touch, event) {
            return true
        }, cc.Handler.EVENT_TOUCH_BEGAN)
        let eventDispatcher = layer.getEventDispatcher()
        eventDispatcher.addEventListenerWithSceneGraphPriority(listenner, layer)
        root.addChild(layer)
    }
    // icon
    let bezierConfig = table(
        [0, cc.p(x1, y1)],
        [0, cc.p(x1 - x2, y1 - y2)],
        [0, cc.p(x2, y2)]
    )
    icon.setScale(1.1)
    icon.setOpacity(0)
    icon.setPosition(cc.p(x1, y1))
    icon.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.FadeIn.create(action.fade || 0), cc.Spawn.create(cc.BezierTo.create(action.moveDura, bezierConfig), cc.Sequence.create(cc.ScaleTo.create(action.moveDura / 2, 1.5), cc.ScaleTo.create(action.moveDura / 2, 1.1))), cc.DelayTime.create(action.duration), cc.CallFunc.create(function () {
        icon.removeFromParent(true)
        if (layer) {
            layer.removeFromParent(true)
        }
    })))
    if (icon.sprite) {
        let delay = (action.delay || 0) + action.moveDura
        icon.sprite.runAction(cc.Sequence.create(cc.DelayTime.create(delay), cc.Spawn.create(cc.FadeOut.create(0.5), cc.ScaleTo.create(0.5, 1.3))))
    } else {
        let delay = (action.delay || 0) + action.moveDura
        icon.runAction(cc.Sequence.create(cc.DelayTime.create(delay), cc.Spawn.create(cc.FadeOut.create(0.5), cc.ScaleTo.create(0.5, 1.3))))
    }
    // icon infiTag 
    if (icon.infiTag) {
        let delay = (action.delay || 0) + action.moveDura
        icon.infiTag.runAction(cc.Sequence.create(cc.DelayTime.create(delay), cc.Spawn.create(cc.FadeTo.create(0.3, 150), cc.ScaleTo.create(0.3, 1.2)), cc.Spawn.create(cc.FadeTo.create(0.2, 255), cc.ScaleTo.create(0.2, 0.85)), cc.ScaleTo.create(0.1, 0.96)))
    }
    // temp tag
    if (icon.temp) {
        let scale = icon.temp.getScale()
        let delay = (action.delay || 0) + action.moveDura + 0.1
        icon.temp.runAction(cc.Sequence.create(cc.DelayTime.create(delay), cc.FadeTo.create(0, 100), cc.ScaleTo.create(0, 0.8), cc.Spawn.create(cc.FadeTo.create(0.2, 255), cc.ScaleTo.create(0.2, scale * 1.2)), cc.ScaleTo.create(0.2, scale * 0.9), cc.ScaleTo.create(0.1, scale)))
    }
    // color bar
    if (icon.infiTag) {
        icon.infiTag.colorBar.stopAllActions()
    }
}
GameGuideAnims.imageMove = function (action, paras, layer) {
    var self = this
    var icon = self.imageElem(action.image || table())
    var size = icon.getContentSize()
    var [x1, y1, width1, height1] = GameGuidePosition.getPosition((action.startPos || table()).posMode, (paras || table()).panel, (action.startPos || table()).p1, (action.startPos || table()).p2, (action.startPos || table()).width, (action.startPos || table()).height, (action.startPos || table()).posRatio, (action.startPos || table()).posAdd, (action.startPos || table()).sizeRatio)
    var [x2, y2, width2, height2] = GameGuidePosition.getPosition((action.endPos || table()).posMode, (paras || table()).panel, (action.endPos || table()).p1, (action.endPos || table()).p2, (action.endPos || table()).width, (action.endPos || table()).height, (action.endPos || table()).posRatio, (action.endPos || table()).posAdd, (action.endPos || table()).sizeRatio)
    var [scaleX, scaleY] = [width1 / size.width, height1 / size.height]
    icon.setScaleX(scaleX)
    icon.setScaleY(scaleY)
    icon.setPosition(cc.p(x1, y1 + size.height * icon.getScaleY()))
    icon.setOpacity(0)
    if (action.animType === "simple") {
        icon.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.FadeIn.create(action.fade || 0), cc.Spawn.create(cc.MoveTo.create(action.duration || 0.5, cc.p(x2, y2)), cc.ScaleTo.create(action.duration || 0.5, width2 / size.width, height2 / size.height)), cc.CallFunc.create(function () {
            icon.removeFromParent(true)
        })))
    } else if (action.animType === "infiProp") {
        GameGuideAnims.imageMoveInfiProp(icon, action, x1, y1, x2, y2, layer)
    } else {
        var startPos = cc.p(icon.getPosition())
        var center = cc.p(startPos.x + width1 / 2, startPos.y - height1 / 2)
        var scales = table(
            1.77,
            1.375,
            1.55,
            1.5
        )
        var startPos1 = cc.pAdd(center, cc.pMul(cc.pSub(startPos, center), scales[1]))
        var startPos2 = cc.pAdd(center, cc.pMul(cc.pSub(startPos, center), scales[2]))
        var startPos3 = cc.pAdd(center, cc.pMul(cc.pSub(startPos, center), scales[3]))
        var startPos4 = cc.pAdd(center, cc.pMul(cc.pSub(startPos, center), scales[4]))
        var endPos = cc.p(x2, y2)
        var center = cc.p(endPos.x + width2 / 2, endPos.y - height2 / 2)
        var endPos1 = cc.pAdd(center, cc.pMul(cc.pSub(endPos, center), scales[4]))
        var endPos2 = cc.pAdd(center, cc.pMul(cc.pSub(endPos, center), scales[1]))
        var fade = action.fade || 2 / 3
        icon.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.FadeIn.create(0), cc.EaseSineIn.create(cc.Spawn.create(cc.MoveTo.create(fade * 0.3124, startPos1), cc.ScaleTo.create(fade * 0.3124, scales[1] * scaleX, scales[1] * scaleY))), cc.Spawn.create(cc.MoveTo.create(fade * 0.25, startPos2), cc.ScaleTo.create(fade * 0.25, scales[2] * scaleX, scales[2] * scaleY)), cc.Spawn.create(cc.MoveTo.create(fade * 0.25, startPos3), cc.ScaleTo.create(fade * 0.25, scales[3] * scaleX, scales[3] * scaleY)), cc.EaseSineOut.create(cc.Spawn.create(cc.MoveTo.create(fade * 0.1874, startPos4), cc.ScaleTo.create(fade * 0.1874, scales[4] * scaleX, scales[4] * scaleY))), cc.Spawn.create(cc.MoveBy.create(action.duration || 0.5, cc.p(cc.pSub(endPos1, startPos4).x, 0)), cc.EaseSineOut.create(cc.MoveBy.create(action.duration || 0.5, cc.p(0, cc.pSub(endPos1, startPos4).y))), cc.ScaleTo.create(action.duration || 0.5, width2 * scales[4] / size.width, height2 * scales[4] / size.height)), cc.Spawn.create(cc.FadeOut.create(action.fade2 || 0.4), cc.MoveTo.create(action.fade2 || 0.4, endPos2), cc.ScaleTo.create(action.fade2 || 0.4, width2 * scales[1] / size.width, height2 * scales[1] / size.height)), cc.CallFunc.create(function () {
            cc.log("REMOVE SELF")
            icon.removeFromParent(true)
        })))
    }
    return icon
}
GameGuideAnims.animalJumpUpWithBubble = function (action, paras) {
    var self = this
    // WARN: maybe multi result
    return self.animalWithBubble(self.animalJumpUp, action, paras, cc.p(0, 0), (action.delay || 0) + 1.3)
}
GameGuideAnims.animalJumpUp = function (action, paras) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    if (vSize.width > GamePlayConfig_Design_Width) {
        scrScale = Math.min(GamePlayConfig_Design_Width / vSize.width, 1)
    }
    scale = scale * scrScale
    var anim = cc.Node.create()
    var animal = cc.CSLoader.createNode("cocos/game_guide_anim1_guideanim_in.csb")
    animal.setName("animal")
    var animation = cc.CSLoader.createTimeline("cocos/game_guide_anim1_guideanim_in.csb")
    animal.setScale(scale)
    if (action.flip) {
        animal.setScaleX(-scale)
    }
    if (action.posMode === "game") {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p2, null, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
        var vSize = cc.Director.getInstance().getVisibleSize()
        animal.setPositionX(action.flip && (-150 * scale + (action.p1 || 0)) || (vSize.width + 150 * scale + (action.p1 || 0)))
    } else {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    }
    anim.addChild(animal)
    animal.runAction(animation)
    animation.setLastFrameCallFunc(function () {
        animation.clearLastFrameCallFunc()
        var pos = cc.p(animal.getPosition())
        var [scaleX, scaleY] = [animal.getScaleX(), animal.getScaleY()]
        animal.removeFromParent(true)
        animal = cc.CSLoader.createNode("cocos/game_guide_anim3_guideanim_front_speak1.csb")
        animation = cc.CSLoader.createTimeline("cocos/game_guide_anim3_guideanim_front_speak1.csb")
        animal.setPosition(pos)
        animal.setScaleX(scaleX)
        animal.setScaleY(scaleY)
        anim.addChild(animal)
        animal.runAction(animation)
        animation.setLastFrameCallFunc(function () {
            animation.clearLastFrameCallFunc()
            var pos = cc.p(animal.getPosition())
            var [scaleX, scaleY] = [animal.getScaleX(), animal.getScaleY()]
            animal.removeFromParent(true)
            animal = cc.CSLoader.createNode("cocos/game_guide_anim3_guideanim_front_speak2.csb")
            animation = cc.CSLoader.createTimeline("cocos/game_guide_anim3_guideanim_front_speak2.csb")
            animal.setPosition(pos)
            animal.setScaleX(scaleX)
            animal.setScaleY(scaleY)
            anim.addChild(animal)
            animal.runAction(animation)
            animation.gotoFrameAndPlay(0, true)
        })
        animation.gotoFrameAndPlay(0, false)
    })
    anim.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.CallFunc.create(function () {
        animation.gotoFrameAndPlay(0, false)
    })))
    return anim
}
GameGuideAnims.animalFadeUpWithBubble = function (action, paras) {
    var self = this
    // WARN: maybe multi result
    return self.animalWithBubble(self.animalFadeUp, action, paras, cc.p(0, 0), (action.delay || 0) + (action.fade || 0))
}
GameGuideAnims.animalFadeUp = function (action, paras) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    if (vSize.width > GamePlayConfig_Design_Width) {
        scrScale = Math.min(GamePlayConfig_Design_Width / vSize.width, 1)
    }
    scale = scale * scrScale
    var anim = cc.Node.create()
    var animal = cc.CSLoader.createNode("cocos/game_guide_anim3_guideanim_front_speak1.csb")
    animal.setName("animal")
    var animation = cc.CSLoader.createTimeline("cocos/game_guide_anim3_guideanim_front_speak1.csb")
    animal.setScale(scale)
    animal.setCascadeOpacityEnabled(true)
    animal.setOpacity(0)
    if (action.flip) {
        animal.setScaleX(-scale)
    }
    if (action.posMode === "game") {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p2, null, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
        var vSize = cc.Director.getInstance().getVisibleSize()
        animal.setPositionX(action.flip && (-150 * scale + (action.p1 || 0)) || (vSize.width + 150 * scale + (action.p1 || 0)))
    } else {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    }
    anim.addChild(animal)
    animal.runAction(animation)
    animation.setLastFrameCallFunc(function () {
        animation.clearLastFrameCallFunc()
        var pos = cc.p(animal.getPosition())
        var [scaleX, scaleY] = [animal.getScaleX(), animal.getScaleY()]
        animal.removeFromParent(true)
        animal = cc.CSLoader.createNode("cocos/game_guide_anim3_guideanim_front_speak2.csb")
        animation = cc.CSLoader.createTimeline("cocos/game_guide_anim3_guideanim_front_speak2.csb")
        animal.setPosition(pos)
        animal.setScaleX(scaleX)
        animal.setScaleY(scaleY)
        anim.addChild(animal)
        animal.runAction(animation)
        animation.gotoFrameAndPlay(0, true)
    })
    animal.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.FadeIn.create(action.fade || 0)))
    anim.runAction(cc.Sequence.create(cc.DelayTime.create((action.delay || 0) + (action.fade || 0)), cc.CallFunc.create(function () {
        animation.gotoFrameAndPlay(0, false)
    })))
    return anim
}
GameGuideAnims.animalSlideUpWithBubble = function (action, paras) {
    var self = this
    // WARN: maybe multi result
    return self.animalWithBubble(self.animalSlideUp, action, paras, cc.p(-500, 0), (action.delay || 0) + (action.slide || 0))
}
GameGuideAnims.animalSlideUp = function (action, paras) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    if (vSize.width > GamePlayConfig_Design_Width) {
        scrScale = Math.min(GamePlayConfig_Design_Width / vSize.width, 1)
    }
    scale = scale * scrScale
    var anim = cc.Node.create()
    var animal = cc.CSLoader.createNode("cocos/game_guide_anim3_guideanim_front_speak1.csb")
    animal.setName("animal")
    var animation = cc.CSLoader.createTimeline("cocos/game_guide_anim3_guideanim_front_speak1.csb")
    animal.setScale(scale)
    if (action.flip) {
        animal.setScaleX(-scale)
    }
    if (action.posMode === "game") {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p2, null, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
        var vSize = cc.Director.getInstance().getVisibleSize()
        animal.setPositionX(action.flip && (-150 * scale + (action.p1 || 0)) || (vSize.width + 150 * scale + (action.p1 || 0)))
    } else {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    }
    anim.addChild(animal)
    animal.runAction(animation)
    animation.setLastFrameCallFunc(function () {
        animation.clearLastFrameCallFunc()
        var pos = cc.p(animal.getPosition())
        var [scaleX, scaleY] = [animal.getScaleX(), animal.getScaleY()]
        animal.removeFromParent(true)
        animal = cc.CSLoader.createNode("cocos/game_guide_anim3_guideanim_front_speak2.csb")
        animation = cc.CSLoader.createTimeline("cocos/game_guide_anim3_guideanim_front_speak2.csb")
        animal.setPosition(pos)
        animal.setScaleX(scaleX)
        animal.setScaleY(scaleY)
        anim.addChild(animal)
        animal.runAction(animation)
        animation.gotoFrameAndPlay(0, true)
    })
    var targetPosition = cc.p(animal.getPosition())
    animal.setPositionX(action.flip && (targetPosition.x - 500 * scale) || (targetPosition.x + 500 * scale))
    animal.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.MoveTo.create(action.slide || 0, targetPosition)))
    anim.runAction(cc.Sequence.create(cc.DelayTime.create((action.delay || 0) + (action.slide || 0)), cc.CallFunc.create(function () {
        animation.gotoFrameAndPlay(0, false)
    })))
    return anim
}
GameGuideAnims.animalJumpDownWithBubble = function (action, paras) {
    var self = this
    // WARN: maybe multi result
    return self.animalWithBubble(self.animalJumpDown, action, paras, cc.p(0, 0), (action.delay || 0) + 1.3)
}
GameGuideAnims.animalJumpDown = function (action, paras) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    if (vSize.width > GamePlayConfig_Design_Width) {
        scrScale = Math.min(GamePlayConfig_Design_Width / vSize.width, 1)
    }
    scale = scale * scrScale
    var anim = cc.Node.create()
    var animal = cc.CSLoader.createNode("cocos/game_guide_anim1_guideanim_in.csb")
    animal.setName("animal")
    var animation = cc.CSLoader.createTimeline("cocos/game_guide_anim1_guideanim_in.csb")
    animal.setScale(scale)
    if (action.flip) {
        animal.setScaleX(-scale)
    }
    if (action.posMode === "game") {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p2, null, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
        var vSize = cc.Director.getInstance().getVisibleSize()
        animal.setPositionX(action.flip && (-150 * scale + (action.p1 || 0)) || (vSize.width + 150 * scale + (action.p1 || 0)))
    } else {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    }
    anim.addChild(animal)
    animal.runAction(animation)
    animation.setLastFrameCallFunc(function () {
        animation.clearLastFrameCallFunc()
        var pos = cc.p(animal.getPosition())
        var [scaleX, scaleY] = [animal.getScaleX(), animal.getScaleY()]
        animal.removeFromParent(true)
        animal = cc.CSLoader.createNode("cocos/game_guide_anim2_guideanim_left_speak1.csb")
        animation = cc.CSLoader.createTimeline("cocos/game_guide_anim2_guideanim_left_speak1.csb")
        animal.setPosition(pos)
        animal.setScaleX(scaleX)
        animal.setScaleY(scaleY)
        anim.addChild(animal)
        animal.runAction(animation)
        animation.setLastFrameCallFunc(function () {
            animation.clearLastFrameCallFunc()
            var pos = cc.p(animal.getPosition())
            var [scaleX, scaleY] = [animal.getScaleX(), animal.getScaleY()]
            animal.removeFromParent(true)
            animal = cc.CSLoader.createNode("cocos/game_guide_anim2_guideanim_left_speak2.csb")
            animation = cc.CSLoader.createTimeline("cocos/game_guide_anim2_guideanim_left_speak2.csb")
            animal.setPosition(pos)
            animal.setScaleX(scaleX)
            animal.setScaleY(scaleY)
            anim.addChild(animal)
            animal.runAction(animation)
            animation.setLastFrameCallFunc(function () {
                animation.clearLastFrameCallFunc()
                var pos = cc.p(animal.getPosition())
                var [scaleX, scaleY] = [animal.getScaleX(), animal.getScaleY()]
                animal.removeFromParent(true)
                animal = cc.CSLoader.createNode("cocos/game_guide_anim2_guideanim_left_speak3.csb")
                animation = cc.CSLoader.createTimeline("cocos/game_guide_anim2_guideanim_left_speak3.csb")
                animal.setPosition(pos)
                animal.setScaleX(scaleX)
                animal.setScaleY(scaleY)
                anim.addChild(animal)
                animal.runAction(animation)
                animation.gotoFrameAndPlay(0, true)
            })
            animation.gotoFrameAndPlay(0, false)
        })
        animation.gotoFrameAndPlay(0, false)
    })
    anim.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.CallFunc.create(function () {
        animation.gotoFrameAndPlay(0, false)
    })))
    return anim
}
GameGuideAnims.animalFadeDownWithBubble = function (action, paras) {
    var self = this
    // WARN: maybe multi result
    return self.animalWithBubble(self.animalFadeDown, action, paras, cc.p(0, 0), (action.delay || 0) + (action.fade || 0))
}
GameGuideAnims.animalFadeDown = function (action, paras) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    if (vSize.width > GamePlayConfig_Design_Width) {
        scrScale = Math.min(GamePlayConfig_Design_Width / vSize.width, 1)
    }
    scale = scale * scrScale
    var anim = cc.Node.create()
    var animal = cc.CSLoader.createNode("cocos/game_guide_anim2_guideanim_left_speak2.csb")
    animal.setName("animal")
    var animation = cc.CSLoader.createTimeline("cocos/game_guide_anim2_guideanim_left_speak2.csb")
    animal.setScale(scale)
    animal.setCascadeOpacityEnabled(true)
    animal.setOpacity(0)
    if (action.flip) {
        animal.setScaleX(-scale)
    }
    if (action.posMode === "game") {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p2, null, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
        var vSize = cc.Director.getInstance().getVisibleSize()
        animal.setPositionX(action.flip && (-150 * scale + (action.p1 || 0)) || (vSize.width + 150 * scale + (action.p1 || 0)))
    } else {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    }
    anim.addChild(animal)
    animal.runAction(animation)
    animation.setLastFrameCallFunc(function () {
        animation.clearLastFrameCallFunc()
        var pos = cc.p(animal.getPosition())
        var [scaleX, scaleY] = [animal.getScaleX(), animal.getScaleY()]
        animal.removeFromParent(true)
        animal = cc.CSLoader.createNode("cocos/game_guide_anim2_guideanim_left_speak3.csb")
        animation = cc.CSLoader.createTimeline("cocos/game_guide_anim2_guideanim_left_speak3.csb")
        animal.setPosition(pos)
        animal.setScaleX(scaleX)
        animal.setScaleY(scaleY)
        anim.addChild(animal)
        animal.runAction(animation)
        animation.gotoFrameAndPlay(0, true)
    })
    animal.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.FadeIn.create(action.fade || 0)))
    anim.runAction(cc.Sequence.create(cc.DelayTime.create((action.delay || 0) + (action.fade || 0)), cc.CallFunc.create(function () {
        animation.gotoFrameAndPlay(0, false)
    })))
    return anim
}
GameGuideAnims.animalSlideDownWithBubble = function (action, paras) {
    var self = this
    // WARN: maybe multi result
    return self.animalWithBubble(self.animalSlideDown, action, paras, cc.p(-500, 0), (action.delay || 0) + (action.slide || 0))
}
GameGuideAnims.animalSlideDown = function (action, paras) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    if (vSize.width > GamePlayConfig_Design_Width) {
        scrScale = Math.min(GamePlayConfig_Design_Width / vSize.width, 1)
    }
    scale = scale * scrScale
    var anim = cc.Node.create()
    var animal = cc.CSLoader.createNode("cocos/game_guide_anim2_guideanim_left_speak2.csb")
    animal.setName("animal")
    var animation = cc.CSLoader.createTimeline("cocos/game_guide_anim2_guideanim_left_speak2.csb")
    animal.setScale(scale)
    if (action.flip) {
        animal.setScaleX(-scale)
    }
    if (action.posMode === "game") {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p2, null, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
        var vSize = cc.Director.getInstance().getVisibleSize()
        animal.setPositionX(action.flip && (-150 * scale + (action.p1 || 0)) || (vSize.width + 150 * scale + (action.p1 || 0)))
    } else {
        animal.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    }
    anim.addChild(animal)
    animal.runAction(animation)
    animation.setLastFrameCallFunc(function () {
        animation.clearLastFrameCallFunc()
        var pos = cc.p(animal.getPosition())
        var [scaleX, scaleY] = [animal.getScaleX(), animal.getScaleY()]
        animal.removeFromParent(true)
        animal = cc.CSLoader.createNode("cocos/game_guide_anim2_guideanim_left_speak3.csb")
        animation = cc.CSLoader.createTimeline("cocos/game_guide_anim2_guideanim_left_speak3.csb")
        animal.setPosition(pos)
        animal.setScaleX(scaleX)
        animal.setScaleY(scaleY)
        anim.addChild(animal)
        animal.runAction(animation)
        animation.gotoFrameAndPlay(0, true)
    })
    var targetPosition = cc.p(animal.getPosition())
    animal.setPositionX(action.flip && (targetPosition.x - 500 * scale) || (targetPosition.x + 500 * scale))
    animal.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.MoveTo.create(action.slide || 0, targetPosition)))
    anim.runAction(cc.Sequence.create(cc.DelayTime.create((action.delay || 0) + (action.slide || 0)), cc.CallFunc.create(function () {
        animation.gotoFrameAndPlay(0, false)
    })))
    return anim
}
GameGuideAnims.animalWithBubble = function (func, action, paras, posAdd, delayTime) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    if (vSize.width > GamePlayConfig_Design_Width) {
        scrScale = Math.min(GamePlayConfig_Design_Width / vSize.width, 1)
    }
    scale = scale * scrScale
    var anim = func.call(self, action, paras)
    var animal = anim.getChildByName("animal")
    var panel = self.bubblePanel(action, delayTime)
    panel.setScale(panel.getScale() * scrScale)
    var distance = (action.flip && 400 || -400) * scale
    var deltaX = (action.flip && 150 || -150) * scale
    var angle = (action.flip && -30 || 30) * ((action.bubblePos || 1) - 2) * Math.PI / 180
    panel.setPosition(cc.p(animal.getPositionX() + deltaX + distance * Math.cos(angle) + (action.flip && -posAdd.x * scale || posAdd.x * scale), animal.getPositionY() + distance * Math.sin(angle) + posAdd.y))
    anim.bubblePanel = panel
    panel.setName("bubblePanel")
    anim.addChild(panel, 10)
    return anim
}
var bubblePosRec = table(
    [0, table(
        [1, "scale", cc.p(1, 1)],
        [1, "anchor", cc.p(0, 0)],
        [1, "pos", cc.p(0, 0)],
        [1, "rotation", 0],
        [1, "delta", cc.p(80, 12)]
    )],
    [0, table(
        [1, "scale", cc.p(-1, 1)],
        [1, "anchor", cc.p(0, 1)],
        [1, "pos", cc.p(0, 0.5)],
        [1, "rotation", 90],
        [1, "delta", cc.p(12, 0)]
    )],
    [0, table(
        [1, "scale", cc.p(1, -1)],
        [1, "anchor", cc.p(0, 1)],
        [1, "pos", cc.p(0, 1)],
        [1, "rotation", 0],
        [1, "delta", cc.p(80, -12)]
    )],
    [0, table(
        [1, "scale", cc.p(-1, 1)],
        [1, "anchor", cc.p(1, 0)],
        [1, "pos", cc.p(1, 0)],
        [1, "rotation", 0],
        [1, "delta", cc.p(-80, 12)]
    )],
    [0, table(
        [1, "scale", cc.p(1, 1)],
        [1, "anchor", cc.p(1, 1)],
        [1, "pos", cc.p(1, 0.5)],
        [1, "rotation", -90],
        [1, "delta", cc.p(-12, 0)]
    )],
    [0, table(
        [1, "scale", cc.p(-1, -1)],
        [1, "anchor", cc.p(1, 1)],
        [1, "pos", cc.p(1, 1)],
        [1, "rotation", 0],
        [1, "delta", cc.p(-80, -12)]
    )]
)
GameGuideAnims.bubblePanel = function (action, delayTime) {
    var self = this
    var posMode = $or(action.flip && 0, 3) + $or(action.bubblePos, 1)
    var size = action.bubbleSize || cc.size(550, 300)
    var ret = cc.Node.create()
    FrameLoader.loadImageWithPlist("cocos/game_guide.plist")
    var bg = ccui.Scale9Sprite.createWithSpriteFrameName("game_guide/bubblebg.png", cc.rect(40, 40, 10, 10))
    var oBgSize = bg.getContentSize()
    bg.setContentSize(size)
    var bgSize = bg.getContentSize()
    ret.addChild(bg)
    var arrow = cc.Sprite.createWithSpriteFrameName("game_guide/arrow.png")
    arrow.setAnchorPoint(cc.p(0.5, 1))
    var rec = clone(bubblePosRec[posMode])
    arrow.setScaleX(rec.scale.x)
    arrow.setScaleY(rec.scale.y)
    arrow.setRotation(bubblePosRec[posMode].rotation)
    var position = cc.p(rec.pos.x * bgSize.width + rec.delta.x, rec.pos.y * bgSize.height + rec.delta.y)
    arrow.setOpacity(0)
    ret.addChild(arrow)
    bg.setAnchorPoint(rec.anchor)
    bg.setPosition(cc.p(bgSize.width * rec.anchor.x - position.x, bgSize.height * rec.anchor.y - position.y))
    var bgAnchor = bg.getAnchorPoint()
    var node = cc.Node.create()
    node.setCascadeOpacityEnabled(true)
    node.setOpacity(0)
    node.setPositionY(-20)
    ret.addChild(node)
    let text = self.createMixedText(getText(tostring(action.text), table([1, "n", "\n"])), action.fontSize || 30, action.fontColor || cc.c4b(0, 0, 0, 255), bg.getContentSize().width - $or((action.textMargin || table()).x, 40) - $or((action.textMargin2 || action.textMargin || table()).x, 40), action.textAlign || "left")

    text.setPosition(cc.p(bg.getPositionX() - rec.anchor.x * bgSize.width + $or((action.textMargin || table()).x, 40), bg.getPositionY() + (1 - rec.anchor.y) * bgSize.height - $or((action.textMargin || table()).y || 15)))
    node.addChild(text)
    var images = table()
    for (let i = 1, v = (action.images || table())[1]; v; i++ , v = (action.images || table())[i]) {
        v.delay = (v.delay || 0) + 0.5
        var image = self.imageElem(v)
        v.scale = v.scale || cc.p(1, 1)
        image.setScaleX(v.scale.x)
        image.setScaleY(v.scale.y)
        var position = v.position || cc.p(0, 0)
        image.setPosition(cc.p(bg.getPositionX() - rec.anchor.x * bgSize.width + position.x, bg.getPositionY() + (1 - rec.anchor.y) * bgSize.height - position.y))
        node.addChild(image)
        table.insert(images, image)
    }
    var anims = table()
    for (let i = 1, v = (action.anims || table())[1]; v; i++ , v = (action.anims || table())[i]) {
        v.delay = (v.delay || 0) + 0.5
        var anim = GameGuideTimelineAnims.timelineAnims(v)
        v.scale = v.scale || cc.p(1, 1)
        anim.setScaleX(v.scale.x)
        anim.setScaleY(v.scale.y)
        var position = v.position || cc.p(0, 0)
        anim.setPosition(cc.p(bg.getPositionX() - rec.anchor.x * bgSize.width + position.x, bg.getPositionY() + (1 - rec.anchor.y) * bgSize.height - position.y))
        node.addChild(anim)
        table.insert(anims, anim)
    }
    var buttons = table()
    for (let i = 1, v = (action.buttons || table())[1]; v; i++ , v = (action.buttons || table())[i]) {
        v.delay = (v.delay || 0) + 0.5
        var button = v.buttonUI || UIButton.create(cc.CSLoader.createNode("cocos/uilibrary_newer_button.csb"), true)
        if (v.size) {
            var size = v.size
            var normal = button.getChildByName("normal")
            var click = button.getChildByName("click")
            var disabled = button.getChildByName("disabled")
            normal.setContentSize(size)
            normal.setPosition(cc.p(-size.width / 2, size.height / 2))
            if (click) {
                click.removeFromParent(true)
            }
            if (disabled) {
                disabled.removeFromParent(true)
            }
            button.setContentSize(size)
        }
        let text1 = button.getChildByName("label")
        text1.ignoreContentAdaptWithSize(true)
        text1.setString(getText(tostring(v.text || getText("clover.text.6"))))
        var size = text1.getVirtualRendererSize()
        text1.setPosition(cc.p(-size.width / 2, size.height / 2 + 7))
        button.setCascadeOpacityEnabled(true)
        v.scale = v.scale || cc.p(1, 1)
        button.setScaleX(v.scale.x)
        button.setScaleY(v.scale.y)
        var position = v.position || cc.p(0, 0)
        button.setPosition(cc.p(bg.getPositionX() - rec.anchor.x * bgSize.width + position.x, bg.getPositionY() + (1 - rec.anchor.y) * bgSize.height - position.y))
        node.addChild(button)
        PushBounceAnim.create(button)
        button.setEnabled(false, true)
        button.on(UIButtonEvent.Click, function (evt) {
            var behavior = v.behavior || "exit"
            if (behavior === "exit") {
                GameGuide.getInstance().onGuideComplete()
            } else if (behavior === "replay") {
                GameGuide.getInstance().onRunReplayGuide(v.para)
            }
        })
        table.insert(buttons, button)
    }
    var skipText
    if (action.skipText) {
        skipText = cc.LabelTTF.create(getText("tutorial.jumpoff"), getText("clover.text.306"))
        var size = skipText.getContentSize()
        skipText.setScale(0.7)
        skipText.setAnchorPoint(cc.p(0, 1))
        skipText.setPosition(cc.p(bg.getPositionX() - rec.anchor.x * bgSize.width + (1 - rec.anchor.x) * bgSize.width - (1 - rec.anchor.x) * size.width + 30, bg.getPositionY() + -rec.anchor.y * bgSize.height))
        skipText.setOpacity(0)
        ret.addChild(skipText)
    }
    arrow.runAction(cc.Sequence.create(cc.DelayTime.create(delayTime), cc.FadeIn.create(0.2)))
    bg.setContentSize(cc.size(bgSize.width / 2, bgSize.height / 2))
    bg.setOpacity(0)
    bg.runAction(cc.Sequence.create(cc.DelayTime.create(delayTime), cc.Spawn.create(cc.FadeIn.create(0.2), cc.Sequence.create(he.HeContentSizeTo.create(0.2, cc.size(1.05 * bgSize.width, 1.05 * bgSize.height)), he.HeContentSizeTo.create(0.3, bgSize)), cc.Sequence.create(cc.DelayTime.create(0.2), cc.CallFunc.create(function () {
        node.runAction(cc.Sequence.create(cc.Spawn.create(cc.FadeIn.create(0.3), cc.MoveBy.create(0.3, cc.p(0, 20))), cc.CallFunc.create(function () {
            for (let i = 1, v = buttons[1]; v; i++ , v = buttons[i]) {
                v.setEnabled(true, true)
            }
        })))
    })), cc.CallFunc.create(function () {
        if (skipText) {
            skipText.runAction(cc.FadeIn.create(0.2))
        }
    }))))
    return ret
}
GameGuideAnims.boardPanel = function (action, delayTime) {
    var self = this
    var ret = cc.Node.create()
    ret.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, null, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    
    ResManager.load("materials/guide_board.png")
    .then(()=>{
        var bg = ccui.Scale9Sprite.create("materials/guide_board.png")
        bg.setCascadeOpacityEnabled(true)
        var bgSize = bg.getContentSize()
        if (action.size) {
            bgSize = clone(action.size)
            bg.setContentSize(bgSize)
        }
        ret.addChild(bg)
        var node = cc.Node.create()
        node.setCascadeOpacityEnabled(true)
        node.setOpacity(0)
        node.setPosition(cc.p(bgSize.width / 2, bgSize.height / 2))
        bg.addChild(node)
        var text = self.createMixedText(getText(tostring(action.text), table([1, "n", "\n"])), action.fontSize || 30, action.fontColor || cc.c4b(255, 255, 255, 255), bgSize.width - ((action.textMargin || table()).x || 30) * 2, action.textAlign || "center")
        text.setPosition(cc.p(bg.getPositionX() - bgSize.width / 2 + ((action.textMargin || table()).x || 30), bg.getPositionY() + bgSize.height / 2 - ((action.textMargin || table()).y || 20)))
        node.addChild(text)
        var images = table()
        for (var i = 1, v = (action.images || table())[1]; v; i++ , v = (action.images || table())[i]) {
            var image = self.imageElem(v)
            v.scale = v.scale || cc.p(1, 1)
            image.setScaleX(v.scale.x)
            image.setScaleY(v.scale.y)
            var position = v.position || cc.p(0, 0)
            image.setPosition(cc.p(bg.getPositionX() - bgSize.width / 2 + position.x, bg.getPositionY() + bgSize.height / 2 - position.y))
            node.addChild(image)
            table.insert(images, image)
        }
        var anims = table()
        for (var i = 1, v = (action.anims || table())[1]; v; i++ , v = (action.anims || table())[i]) {
            v.delay = (v.delay || 0) + 0.43
            var anim = GameGuideTimelineAnims.timelineAnims(v)
            v.scale = v.scale || cc.p(1, 1)
            anim.setScaleX(v.scale.x)
            anim.setScaleY(v.scale.y)
            var position = v.position || cc.p(0, 0)
            anim.setPosition(cc.p(bg.getPositionX() - bgSize.width / 2 + position.x, bg.getPositionY() + bgSize.height / 2 - position.y))
            node.addChild(anim)
            table.insert(anims, anim)
        }
        bg.setPositionX(bg.getPositionX() - bgSize.width / 2)
        bg.setOpacity(0)
        bg.runAction(
            cc.Sequence.create(
                cc.DelayTime.create(delayTime),
                cc.Spawn.create(
                    cc.FadeIn.create(0.2),
                    cc.MoveBy.create(0.2, cc.p(bgSize.width / 2 + 30, 0))
                ),
                cc.CallFunc.create(function () {
                    // FIXME: Scale9Sprite 子节点位置未更新，概率出现，临时处理
                    node._renderCmd.setDirtyFlag(1)
                    node.runAction(cc.FadeIn.create(0.23))
                }),
                cc.MoveBy.create(0.23, cc.p(-30, 0)),
                // FIXME: Scale9Sprite  子节点位置未更新，概率出现，临时处理
                cc.CallFunc.create(function() {
                    node._renderCmd.setDirtyFlag(1)
                })
            ))
    })
    .catch(()=>{})
    
    return ret
}
GameGuideAnims.imageElem = function (config) {
    var self = this
    var ret
    if (config.type === "prop") {
        ret = UIItemBuilder.createPropIcon(config.id)
    } else if (config.type === "goods") {
        ret = UIItemBuilder.createGoodsIcon(config.id)
    } else if (config.type === "frame") {
        FrameLoader.loadImageWithPlist(config.file)
        ret = cc.Sprite.createWithSpriteFrameName(config.name)
    } else if (config.type === "file") {
        ret = cc.Sprite.create(config.file)
    } else {
        ret = cc.Node.create()
    }
    ret.setAnchorPoint(cc.p(0, 1))
    return ret
}
GameGuideAnims.createMixedText = function (text, fontSize, fontColor, width, align) {
    var self = this
    // 字符串分组
    let colorReg = /{\w+=[\w,.]+}/g
    var textArr = table()
    var lastEnd = 0
    while ((execResult = colorReg.exec(text)) != null) {
        let start = execResult.index + 1
        let fin = execResult.index + execResult[0].length
        if (!start) {
            break
        }
        var match = string.sub(text, lastEnd + 1, start - 1)
        if (string.len(match) > 0) {
            table.insert(textArr, match)
        }
        match = string.sub(text, start, fin)
        if (string.len(match) > 0) {
            table.insert(textArr, match)
        }
        lastEnd = fin
    }
    var text = string.sub(text, lastEnd + 1)
    if (string.len(text) > 0) {
        table.insert(textArr, text)
    }
    fontColor = cc.c4b(fontColor.r,fontColor.g,fontColor.b,fontColor.a);
    // 颜色分组
    var [colorArr, lastIdx, lastColor] = [table(), 0, fontColor]
    let rgbaReg = /{c=(\d+),(\d+),(\d+),(\d+)}/g
    for (var i = 1, v = textArr[1]; v; i++ , v = textArr[i]) {
        var r, g, b, a
        var t
        if ((t = rgbaReg.exec(v)) != null) {
            var res1 = t[1]
            var res2 = t[2]
            var res3 = t[3]
            var res4 = t[4]
            if (res1 == null) break
                ;[r, g, b, a] = [tonumber(res1), tonumber(res2), tonumber(res3), tonumber(res4)]
        } else {
            [r, g, b, a] = [fontColor.r, fontColor.g, fontColor.b, fontColor.a];
            continue
        }
        if ($bool(r)) {
            var group = table()
            var $var277 = lastIdx + 1, $limit278 = i - 1
            for (var j = $var277; j <= $limit278; j += 1) {
                table.insert(group, textArr[j])
            }
            table.insert(colorArr, table([1, "color", lastColor], [1, "group", group]))
            lastIdx = i
            lastColor = cc.c4b(r, g, b, a)
        }
    }
    var group = table()
    var $var281 = lastIdx + 1, $limit282 = $len(textArr)
    for (var j = $var281; j <= $limit282; j += 1) {
        table.insert(group, textArr[j])
    }
   
    table.insert(colorArr, table([1, "color", lastColor], [1, "group", group]))

    // 去掉其它参数标识（有需求再作其它处理）
    for (var i = 1, v = colorArr[1]; v; i++ , v = colorArr[i]) {
        var group = table()
        for (var j = 1, w = v.group[1]; w; j++ , w = v.group[j]) {
            if (!w.match(colorReg)) {
                table.insert(group, w)
            }
        }
        v.group = group
    }
    // 创建文本（如果添加了新的标识 这里应该也需要对其有所处理）
    var node = cc.Node.create()
    node.setCascadeOpacityEnabled(true)
    var [deltaX, deltaY] = [0, 0]
    var [lastText, lineTable] = [null, table()]
    for (var i = 1, v = colorArr[1]; v; i++ , v = colorArr[i]) {
        for (var j = 1, w = v.group[1]; w; j++ , w = v.group[j]) {
            var refDeltaX = deltaX
            var [strTable, fakeText] = [table(""), cc.LabelTTF.create("", getText("clover.text.306"), 30)]
            var [scale, count] = [fontSize / 30, 0]
            let tArr = w.split('')
            for (let i = 0; i < tArr.length; i++) {
                let uchar = tArr[i]
                if (uchar !== "\n") {
                    fakeText.setString(strTable[$len(strTable)] + uchar)
                    var size = fakeText.getContentSize()
                    if ((width || 0) > 0 && (refDeltaX + size.width * scale) > (width || 0) && (refDeltaX > 0 || count > 0 && size.width * scale > 0)) {
                        count = 1
                        table.insert(strTable, uchar)
                        fakeText.setString(uchar)
                        refDeltaX = 0
                    } else {
                        count = count + 1
                        strTable[$len(strTable)] = strTable[$len(strTable)] + uchar
                    }
                } else {
                    count = 0
                    table.insert(strTable, "")
                    refDeltaX = 0
                }
            }
            strTable = table.filter(strTable, function (v) {
                return v !== ""
            })
            for (var k = 1, u = strTable[1]; u; k++ , u = strTable[k]) {
                var text = cc.LabelTTF.create(u, getText("clover.text.306"), 30)
                text.setScale(fontSize / 30)
                if (k > 1) {
                    deltaX = 0
                    deltaY = deltaY - lastText.getContentSize().height * lastText.getScale()
                    table.insert(lineTable, table())
                } else if (lastText && deltaX > 0) {
                    var [lSize, cSize] = [lastText.getContentSize(), text.getContentSize()]
                    if ((width || 0) > 0 && deltaX + cSize.width * text.getScale() > (width || 0)) {
                        deltaX = 0
                        deltaY = deltaY - lSize.height * lastText.getScale()
                        table.insert(lineTable, table())
                    }
                } else if ($len(lineTable) <= 0) {
                    table.insert(lineTable, table())
                }
                text.setColor(cc.c3b(v.color.r, v.color.g, v.color.b))
                text.setOpacity(v.color.a)
                text.setAnchorPoint(cc.p(0, 1))
                text.setPosition(cc.p(deltaX, deltaY))
                deltaX = deltaX + text.getContentSize().width * text.getScale()
                table.insert(lineTable[$len(lineTable)], text)
                text.setLocalZOrder(0)
                lastText = text
                node.addChild(text)
            }
        }
    }
    if (align === "left") { // 左对齐
    } else if (align === "right") { // 右对齐
        for (var i = 1, v = lineTable[1]; v; i++ , v = lineTable[i]) {
            var totalWidth = 0
            for (var j = 1, w = v[1]; w; j++ , w = v[j]) {
                totalWidth = totalWidth + w.getContentSize().width * w.getScale()
            }
            var base = width - totalWidth
            totalWidth = 0
            for (var j = 1, w = v[1]; w; j++ , w = v[j]) {
                w.setPositionX(base + totalWidth)
                totalWidth = totalWidth + w.getContentSize().width * w.getScale()
            }
        }
    } else { // 默认居中对齐
        for (var i = 1, v = lineTable[1]; v; i++ , v = lineTable[i]) {
            var totalWidth = 0
            for (var j = 1, w = v[1]; w; j++ , w = v[j]) {
                totalWidth = totalWidth + w.getContentSize().width * w.getScale()
            }
            var base = (width - totalWidth) / 2
            totalWidth = 0
            for (var j = 1, w = v[1]; w; j++ , w = v[j]) {
                w.setPositionX(base + totalWidth)
                totalWidth = totalWidth + w.getContentSize().width * w.getScale()
            }
        }
    }
    return node
}

GameGuideAnims.singleBubbleNew = function (action, paras) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    scale = scale * scrScale
    var bubble = self.bubblePanelNew(action, (action.delay || 0) + (action.fade || 0))
    bubble.setScale(scale * bubble.getScale())
    bubble.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    return bubble
}
GameGuideAnims.bubblePanelNew = function (action, delayTime) {
    let self = this
    let posMode = $or(action.flip && 0, 3) + $or(action.bubblePos, 1)
    let size = action.bubbleSize || cc.size(550, 300)
    let ret = cc.Node.create()
    let bg = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/com_bigpop_bg.png", cc.rect(25, 25, 2, 2))
    bg.setContentSize(size)
    ret.addChild(bg)
    let bgSize = bg.getContentSize()
    let rec = clone(bubblePosRec[posMode])

    let textMargin = action.textMargin || cc.p(0,0)
    let textAlign = action.textAlign || "left"
    // let text = self.createMixedText(getText(tostring(action.text), table([1, "n", "\n"])), action.fontSize || 30, action.fontColor || cc.c4b(0, 0, 0, 255), bg.getContentSize().width - $or((action.textMargin || table()).x, 40) - $or((action.textMargin2 || action.textMargin || table()).x, 40), action.textAlign || "left")
    let text = cc.LabelTTF.create(getText(tostring(action.text)), null, action.fontSize || 30)
    text.setDimensions(bgSize.width - textMargin.x,0)
    text.setColor(action.fontColor || cc.c4b(0, 0, 0, 255))
    text.setPosition(bgSize.width/2,bgSize.height/2)
    let alignment = textAlign == "left" ? cc.TEXT_ALIGNMENT_LEFT : textAlign == "right" ? cc.TEXT_ALIGNMENT_RIGHT : cc.TEXT_ALIGNMENT_CENTER 
    text.setAlignment(alignment)

    bg.addChild(text)

    bg.setOpacity(0)
    bg.setCascadeOpacityEnabled(true)
    bg.runAction(cc.Sequence.create(
        cc.DelayTime.create(delayTime),
        cc.Spawn.create(cc.FadeIn.create(0.2))
        ))
     
    return ret
}

GameGuideAnims.dynamicGuideBubble = function (action, paras) {
    var self = this
    var scale = action.scale || 1
    var vSize = cc.Director.getInstance().getWinSize()
    var scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    scale = scale * scrScale
    var bubble = self.dynamicBubblePanel(action, (action.delay || 0) + (action.fade || 0))
    bubble.setScale(scale * bubble.getScale())
    bubble.setPosition(cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio)))
    return bubble
}
GameGuideAnims.dynamicBubblePanel = function (action, delayTime) {
    let ret = cc.CSLoader.createNode(`cocos/guide_guide_node.csb`)
    let label = ret.getChildByName("label")
    let text = action.text || ""
    text = text.replace('\\n', '\n')
    // text = getText("get.happycoin.bubble.ios")
    // let contentLabel = cc.LabelTTF.create(text, FONT_DEF.microsoftYahei_30_noStroke)
    let contentLabel = cc.LabelTTF.create(text, null, 27)
    // contentLabel.setColor(label.getTextColor())
    contentLabel.setColor(cc.color(137,73,38))

    label.setVisible(false)
    let bg = ret.getChildByName("bg")
    bg.addChild(contentLabel)
    contentLabel.setDimensions(360, 0)
    // contentLabel.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    contentLabel.setPosition(bg.width/2+50,bg.height/2)

    ret.setOpacity(0)
    ret.setCascadeOpacityEnabled(true)
    ret.runAction(cc.Sequence.create(
        cc.DelayTime.create(delayTime),
        cc.Spawn.create(cc.FadeIn.create(0.2))
        ))
     
    return ret
}
GameGuideAnims.animalDialogV2 = function (action, paras) {
    let self = this
    FrameLoader.loadImageWithPlist("cocos/guide_dialog.plist")
    let scale = action.scale || 1
    let vSize = cc.Director.getInstance().getWinSize()
    let scrScale = Math.min(vSize.height / GamePlayConfig_Design_Height, 1)
    if (vSize.width > GamePlayConfig_Design_Width) {
        scrScale = Math.min(GamePlayConfig_Design_Width / vSize.width, 1)
    }
    scale = scale * scrScale
    let temp = scale;
    if(vSize.height > GamePlayConfig_Design_Height) {
        temp = GamePlayConfig_Tile_ScaleY
    }
   
    let pos = cc.p(vSize.width / 2 + action.p1, vSize.height / 2 + action.p2 * temp)
    if (action.posMode && action.posMode == "panel") {
        pos = cc.p(action.p1, action.p2)
    }

    let dialog = ccui.Scale9Sprite.createWithSpriteFrameName("guide_dialog/guide_talk.png", cc.rect(177, 76, 22, 24));
    dialog.setContentSize(568,181);
    dialog.setAnchorPoint(0.5,0.5);
    dialog.setPosition(pos)
    dialog.setScale(scale)
    let text = self.createMixedText(action.realText || getText(tostring(action.text), table([1, "n", "\n"])), action.fontSize || 30, action.fontColor ||
        cc.c4b(117, 115, 68, 255), action.width || 380, action.textAlign || "left")
    text.setPosition(170, 140 + (action.dy || 0))
    dialog.addChild(text);
    return dialog
}
GameGuideAnims.animalDialogV2Hand = function (action, paras) {
    FrameLoader.loadImageWithPlist("cocos/guide_dialog.plist")
    let vSize = cc.Director.getInstance().getWinSize()
    let [x, y, width, height] = GameGuidePosition.getPosition(action.posMode, null, action.p1, action.p2, 1, 1)

    let hand = cc.Sprite.createWithSpriteFrameName("guide_dialog/guide_hand.png")
    hand.setAnchorPoint(cc.p(0, 1))
    let endPos = cc.p(x + width / 2, y + height / 2)
    let startPos = cc.p(x + width / 2, y + height / 2)
    switch (action.dir) {
        case "left2right":
            startPos.x -= width;
            break;
        case "right2left":
            startPos.x += width;
            break;
        case "up2down":
            startPos.y += height;
            break;
        case "down2up":
            startPos.y -= height;
            break;
    }

    let track = null
    if (paras.track) {
        track = paras.track
    }

    let func1 = function () {
        hand.setPosition(startPos)
        hand.setOpacity(0)
        track && track.setOpacity(0)
    }
    let func2 = function () {
        track && track.runAction(cc.FadeIn.create(0.1))
    }
    let func3 = function () {
        track && track.runAction(cc.FadeOut.create(0.1))
    }

    hand.runAction(cc.RepeatForever.create(cc.Sequence.create(
        cc.CallFunc.create(func1),
        cc.FadeIn.create(0.13),
        cc.CallFunc.create(func2),
        cc.MoveTo.create(0.345, endPos),
        cc.DelayTime.create(0.13),
        cc.CallFunc.create(func3),
        cc.FadeOut.create(0.08),
        cc.DelayTime.create(2)
    )))

    return hand
}
GameGuideAnims.animalDialogV2HandTrack = function (action, paras) {
    FrameLoader.loadImageWithPlist("cocos/guide_dialog.plist")
    let wSize = cc.Director.getInstance().getWinSize()
    let [x, y, width, height] = GameGuidePosition.getPosition(action.posMode, null, action.p1, action.p2, 1, 1)

    let line = cc.Sprite.createWithSpriteFrameName("guide_dialog/guide_line.png")
    line.setPosition(x + width / 2, y + height / 2)

    switch (action.dir) {
        case "left2right":
            line.x -= width / 2;
            line.setRotation(0)
            break;
        case "right2left":
            line.setRotation(180)
            break;
        case "up2down":
            line.setAnchorPoint(cc.p(0.2, 0.5))
            line.setRotation(-90)
            break;
        case "down2up":
            line.y -= height / 2;
            line.setRotation(90)
            break;
    }

    return line
}
GameGuideAnims.handV2Click = function (action, paras) {
    var self = this
    var anim = cc.Node.create()
    FrameLoader.loadImageWithPlist("cocos/guide_dialog.plist");
    //
    var hand = cc.Sprite.createWithSpriteFrameName("guide_dialog/guide_hand.png")
    hand.setAnchorPoint(cc.p(0.55, 0.07))
    var pos = cc.p(...GameGuidePosition.getPosition(action.posMode, (paras || table()).panel, action.p1, action.p2, action.width, action.height, action.posRatio, action.posAdd, action.sizeRatio))
    let startPos = cc.p(pos.x + 60, pos.y - 120);
    hand.setPosition(startPos);
    //光圈
    let light = cc.Sprite.createWithSpriteFrameName("guide_dialog/light.png");
    light.setOpacity(0);
    light.setPosition(pos);
    //
    let func1 = function () {
        hand.setPosition(startPos);
        hand.setOpacity(0);
        hand.setRotation(10);
    }
    let func2 = function () {
        light.setScale(0.66);
        light.runAction(cc.Spawn.create(
            cc.Sequence.create(
                cc.FadeIn.create(0.167),
                cc.FadeOut.create(0.167),
            ),
            cc.EaseSineInOut.create(cc.ScaleTo.create(0.334, 1.42), 1),
        ))
    }

    hand.runAction(cc.RepeatForever.create(cc.Sequence.create(
        cc.CallFunc.create(func1),
        cc.Spawn.create(
            cc.FadeIn.create(0.167),
            cc.EaseSineInOut.create(cc.RotateBy.create(0.333, -10), 1),
            cc.EaseSineInOut.create(cc.MoveBy.create(0.333, cc.p(-10, 10)), 1)
        ),
        cc.CallFunc.create(func2),
        cc.Spawn.create(
            cc.EaseSineInOut.create(cc.RotateBy.create(0.333, 5), 1),
            cc.EaseSineInOut.create(cc.MoveBy.create(0.333, cc.p(10, -10)), 1)
        ),
        cc.Spawn.create(
            cc.EaseSineInOut.create(cc.RotateBy.create(0.333, -5), 1),
            cc.EaseSineInOut.create(cc.MoveBy.create(0.333, cc.p(-10, 10)), 1)
        ),
        cc.CallFunc.create(func2),
        cc.Spawn.create(
            cc.Sequence.create(cc.FadeOut.create(0.3332)),
            cc.EaseSineInOut.create(cc.RotateBy.create(0.333, 10), 1),
            cc.EaseSineInOut.create(cc.MoveBy.create(0.333, cc.p(10, -10)), 1)
        ),
        cc.DelayTime.create(0.5),
    )))
    //
    anim.addChild(light);
    anim.addChild(hand);
    //
    anim.remove = function (self) {
        self.removeFromParent(true)
    }
    return anim
}
module.exports = GameGuideAnims
